const reserved = new Set([
  "www",
  "app",
  "api",
  "admin",
  "auth",
  "blog",
  "checkout",
  "help",
  "login",
  "support",
  "mail",
  "smtp",
  "cdn",
  "assets",
  "status",
  "dev",
  "staging",
  "scanner",
]);
export function shopfrontSlugFromHost(hostname) {
  const match = hostname
    .toLowerCase()
    .match(/^([a-z0-9]+(?:-[a-z0-9]+)*)\.whoppatix\.com$/);
  return match &&
    !reserved.has(match[1]) &&
    match[1].length >= 3 &&
    match[1].length <= 40
    ? match[1]
    : null;
}
